import { CustomerOrderDeatils } from './CustomerOrder';

export const data: CustomerOrderDeatils[] = [];

export const orderStatus =[
'CREATED','INPROGRESS','CONFIRMED'
]
